<template>
    <div>
        <h4>Répartition des parts</h4>

        <b-card no-body class="shadow-sm mb-3">
            <b-card-body>
                <div v-if="associates.length>0" class="mb-3">
                    <b-row>
                        <b-col sm="6" class="small">Associé</b-col>
                        <b-col sm="2" class="small">Pleine Prop.</b-col>
                        <b-col sm="2" class="small">Nue Prop.</b-col>
                        <b-col sm="2" class="small">Usufruit</b-col>
                    </b-row>

                    <div v-for="associate in associates"
                         :key="'ask' + associate.id" class="my-1">
                        <asset-repartition-edit :associate="associate"/>
                    </div>
                </div>
                <b-alert :variant="alertVariant" show class="mt-0 mb-0">
                    {{ alertMessage }}
                </b-alert>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import AssetRepartitionEdit from "./AssetRepartitionEdit.vue";

export default {
    name: 'AssetRepartition',
    components: {AssetRepartitionEdit},

    data() {
        return {
            form: {
                shares: 0,
                usufruct_shares: 0,
                bare_ownership_shares: 0,
            },
        }
    },

    computed: {
        ...mapState({
            client: (state) => state.legalVM.client,
        }),

        associates() {
            return this.client.associates.data
        },

        noAssociate() {
            return (
                this.associates.length === 0 && !this.searching && !this.editing
            )
        },

        notAffectedShares() {
            return this.client.shares - this.client.affected_shares
        },

        alertVariant() {
            if (this.client.shares === 0 || this.notAffectedShares !== 0) {
                return 'danger'
            }
            return 'success'
        },

        alertMessage() {
            if (this.client.shares === 0) {
                return "Le nombre de parts n'a pas été renseigné"
            }
            if (this.notAffectedShares === 1) {
                return "1 part n'est pas affectée"
            }
            if (this.notAffectedShares > 1) {
                return `${this.notAffectedShares} parts ne sont pas affectées`
            }
            if (this.notAffectedShares < 0) {
                return `${-this.notAffectedShares} parts sont affectées en trop`
            }
            return `Les ${this.client.shares} parts sont bien affectées`
        },
    },
}
</script>

<style scoped></style>
